import { IconButton, Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import React from 'react';
import { useHistory } from 'react-router-dom';

const BackButton = () => {
  const history = useHistory();

  return (
    <IconButton
      disableRipple
      onClick={() => { history.push('/holding-maintainer'); }}
    >
      <ArrowBackIcon color="secondary" />
      <Typography color="primary">Volver</Typography>
    </IconButton>
  );
};

export default BackButton;
